<template>
  <i class="del_container"></i>
</template>

<script>
export default {
  data() {
    return {

    };
  },
  components: {

  }
};
</script>

<style scoped lang="stylus">
.del_container {
  display inline-block
  width 24px
  height 24px
  background url('./images/commodity_icon_sheet_close@3x.png') center no-repeat
  background-size 24px 24px
}
</style>
